/* Meta pixel for the published product LP. Pixel ID and absence of a Shopify integration confirmed by the owner. */
(() => {
  'use strict';
  const config = document.currentScript;
  const pixelId = config?.dataset.metaPixelId || '';
  if (!/^\d{10,20}$/.test(pixelId) || location.hostname !== 'inunokurashi.jp' || !/^\/pages\/inunoibasho\/?$/.test(location.pathname)) return;
  if (window.__inunokurashiMetaPixel) return;
  const state = window.__inunokurashiMetaPixel = { pixelId, status: 'waiting_for_privacy', pageViewSent: false };
  // Do not add a second top-level Meta implementation on a page already managed by another integration.
  if (window.fbq) { state.status = 'existing_integration'; return; }
  let allowed = false;
  let initialized = false;
  function send(...args) { window.fbq(...args); }
  function start() {
    if (initialized) return true;
    if (window.fbq) { state.status = 'existing_integration'; return false; }
    const fbq = window.fbq = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    window._fbq = window._fbq || fbq;
    fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
    // No customer name, email, phone number or LINE profile is passed to Meta.
    send('set', 'autoConfig', false, pixelId);
    send('init', pixelId);
    send('trackSingle', pixelId, 'PageView');
    state.pageViewSent = true;
    initialized = true;
    const sdk = document.createElement('script');
    sdk.async = true;
    sdk.src = 'https://connect.facebook.net/en_US/fbevents.js';
    sdk.onerror = () => { state.status = 'sdk_unavailable'; };
    document.head.appendChild(sdk);
    return true;
  }
  function syncConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' || typeof privacy.saleOfDataAllowed !== 'function') {
      allowed = false; state.status = 'privacy_unavailable'; return;
    }
    allowed = privacy.marketingAllowed() && privacy.saleOfDataAllowed();
    if (allowed) {
      if (initialized) send('consent', 'grant');
      else if (!start()) { allowed = false; return; }
      state.status = 'active';
    } else {
      if (initialized) send('consent', 'revoke');
      state.status = 'consent_not_granted';
    }
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-line]');
    if (!link || !allowed || !initialized) return;
    const placement = ['hero', 'benefits', 'selection', 'footer', 'sticky', 'menu'].includes(link.dataset.line) ? link.dataset.line : 'other';
    // A click is not a completed LINE friend registration or purchase.
    send('trackSingleCustom', pixelId, 'LINEClick', { placement, product_name: 'うちの子の特等席' });
  });
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (error) state.status = 'privacy_unavailable';
      else syncConsent();
    });
  } else state.status = 'privacy_unavailable';
})();
